import { useMemo } from "react";
import { useApi, apiResolver } from "@/api/useApi";
import {
  Instruction,
  CreateInstructionDto,
  UpdateInstructionDto,
} from "./Instruction.model";

export function useInstructionApi() {
  const { api } = useApi();

  return useMemo(
    () => ({
      createInstruction: async (input: CreateInstructionDto) =>
        apiResolver<Instruction>(api.post("/platform/instructions", input)),
      updateInstruction: async (
        instructionId: string,
        input: UpdateInstructionDto
      ) =>
        apiResolver<Instruction>(
          api.put(`/platform/instructions/${instructionId}`, input)
        ),
      deleteInstruction: async (instructionId: string) =>
        apiResolver<{ success: boolean }>(
          api.delete(`/platform/instructions/${instructionId}`)
        ),
      getInstruction: async (instructionId: string) =>
        apiResolver<Instruction | null>(
          api.get(`/platform/instructions/${instructionId}`)
        ),
      getInstructions: async (topicReleasePolicyId?: string) =>
        apiResolver<Instruction[]>(
          api.get(
            `/platform/instructions${topicReleasePolicyId ? `?topicReleasePolicyId=${topicReleasePolicyId}` : ""}`
          )
        ),
    }),
    [api]
  );
}
